export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID as string;
export const GA4_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID as string;
export const SEGMENT_ID_WEB = process.env.NEXT_PUBLIC_SEGMENT_ID as string;
export const SEGMENT_ID_APP = process.env.NEXT_PUBLIC_SEGMENT_ID_APP as string;

export const UTM = {
  sources: {
    tripManager: 'trip.numastays.com',
    email: 'email',
  },
  campaigns: {
    startDci: 'start-dci',
    continueDci: 'continue-dci',
  },
  media: {
    none: 'none',
  },
  contents: {
    tripDetailHeader: 'trip-detail-header',
    myTripsTripItem: 'my-trips-trip-item',
  },
} as const;
